/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getOnboardingSuggestedStarterPacksSkeleton.defs.js'
export * as $defs from './getOnboardingSuggestedStarterPacksSkeleton.defs.js'
